import React, { useState } from 'react';
import Dialog from 'src/components/common/Dialog.redesign';
import Form from 'src/components/controls/forms/Form';
import FormTextBox from 'src/components/controls/forms/redesign/FormTextbox';
import { FormErrors } from 'src/util/FormErrors';
import Button from 'src/components/controls/forms/redesign/FormButton';
import Checkbox from 'src/components/controls/forms/Checkbox';
import useFetch from 'use-http';
import { Url } from 'src/api';
import { useSelector } from 'react-redux';
import { IRootState } from 'src/reducers';
import AnimateHeight from 'react-animate-height';

interface ICopyLeaseholdDialogProps {
    ownershipId: number;
    onLeaseholdCopied: (id: number) => void;
    onCloseDialog?: () => void;
}

interface IFormData {
    leaseholdNumber: number;
}

const CopyLeaseholdDialog: React.FC<ICopyLeaseholdDialogProps> = (props) => {
    const defaultOptions: { wi: boolean; orri: boolean; poolingStatus: boolean } = {
        wi: true,
        orri: true,
        poolingStatus: true,
    };

    const appContext = useSelector((state: IRootState) => state.appContext);

    const [options, setOptions] = useState(defaultOptions);
    const [error, setError] = useState(undefined);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const { post, response } = useFetch();

    const onValidate = (values: IFormData) => {
        const errors: FormErrors<IFormData> = {};

        if (!values.leaseholdNumber) {
            errors.leaseholdNumber = 'Must enter Leasehold Number';
        } else if (isNaN(values.leaseholdNumber)) {
            errors.leaseholdNumber = 'Leasehold Number must be a number';
        }

        return errors;
    };

    const onSubmit = async (values: IFormData) => {
        console.log('v', values);

        setError(undefined);
        values.leaseholdNumber = parseInt(values.leaseholdNumber + '', 10);

        const body = {
            leaseholdNumber: values.leaseholdNumber,
            copyWi: options.wi,
            copyOrri: options.orri,
            copyPoolingStatus: options.poolingStatus,
        };

        setIsSubmitting(true);
        await post(`${Url.tract.copyLeasehold(appContext)}`, body);
        setIsSubmitting(false);

        if (response.status === 400) {
            setError(response.data);
        } else if (response.ok) {
            setIsSubmitting(false);
            props.onLeaseholdCopied(response.data.id);
            props.onCloseDialog();
        }
    };

    const updateChecks = (event: React.ChangeEvent<HTMLInputElement>, level: number) => {
        const value = event.currentTarget.checked;

        switch (level) {
            case 1: {
                if (!value && options.orri) {
                    setOptions({ ...options, wi: value, orri: false });
                } else {
                    setOptions({ ...options, wi: value });
                }
                break;
            }
            case 2: {
                setOptions({ ...options, orri: value });
                break;
            }
            default: {
                return;
            }
        }
    };

    const updatePoolingStatus = (event: React.ChangeEvent<HTMLInputElement>) => {
        setOptions({ ...options, poolingStatus: event.currentTarget.checked });
    };

    return (
        <Dialog title="Copy Leasehold">
            <Form onSubmit={onSubmit} validate={onValidate}>
                <AnimateHeight height={error ? 'auto' : 0} duration={300}>
                    <div
                        className="dlc-form-textbox-error"
                        style={{ marginBottom: '2rem', padding: '1rem', border: '1px solid black', background: 'white', textAlign: 'center' }}
                    >
                        {error}
                    </div>
                </AnimateHeight>
                <FormTextBox label="Leashold Number" name="leaseholdNumber" />
                <div style={{ width: '50%', display: 'inline-block' }}>
                    <Checkbox label="Working Interest" value={options.wi} onChange={(e) => updateChecks(e, 1)} />
                </div>
                <div style={{ width: '50%', display: 'inline-block' }}>
                    <Checkbox label="Overriding Royalty Interest" value={options.orri} onChange={(e) => updateChecks(e, 2)} disabled={!options.wi} />
                </div>
                <div style={{ width: '50%' }}>
                    <Checkbox label="Pooling Status" value={options.poolingStatus} onChange={updatePoolingStatus} />
                </div>
                <Button type="submit" text="Submit" disabled={isSubmitting} />
            </Form>
        </Dialog>
    );
};

export default CopyLeaseholdDialog;



// WEBPACK FOOTER //
// ./src/components/project/sections/TractComponents/dialogs/CopyOwnershipDialog.tsx